import { Navigate } from 'react-router-dom';
import { usePermissions } from '../context/PermissionsContext';
import type { PermissionAction } from '../config/navigation';

interface ProtectedRouteProps {
  module: string;
  action?: PermissionAction;
  children: React.ReactNode;
}

export function ProtectedRoute({ module, action = 'read', children }: ProtectedRouteProps) {
  const { can, loading } = usePermissions();

  if (loading) {
    return <div className="p-6 text-gray-500 text-sm">Verificando permisos…</div>;
  }

  if (!can(module, action)) {
    return <Navigate to="/forbidden" replace />;
  }

  return <>{children}</>;
}

export function PermissionGate({
  module,
  action = 'read',
  criticalPoint,
  children,
  fallback = null,
}: {
  module?: string;
  action?: PermissionAction;
  criticalPoint?: string;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}) {
  const { can, canCritical, loading } = usePermissions();

  if (loading) return null;
  if (criticalPoint) {
    return canCritical(criticalPoint) ? <>{children}</> : <>{fallback}</>;
  }
  if (module && !can(module, action)) return <>{fallback}</>;
  return <>{children}</>;
}
